"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThumbnailBlurred = void 0;
var isThumbnailBlurred = function (user) {
    return user.requiresAgeConfirmation && (!user.isAuthenticated || user.isFreemium);
};
exports.isThumbnailBlurred = isThumbnailBlurred;
//# sourceMappingURL=UserService.js.map